import { render } from "./EventName.vue?vue&type=template&id=765eb23b&scoped=true"
import script from "./EventName.vue?vue&type=script&lang=js"
export * from "./EventName.vue?vue&type=script&lang=js"

import "./EventName.vue?vue&type=style&index=0&id=765eb23b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765eb23b"]])

export default __exports__